import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { NgxSpinnerService } from 'ngx-spinner';
import { Doc } from 'src/app/models/Personel';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';
import { PersonelService } from 'src/app/services/personel.service';


@Component({
  selector: 'app-puantaj',
  templateUrl: './puantaj.component.html',
  styleUrls: ['./puantaj.component.css']
})
export class PuantajComponent implements OnInit {


  pdfSrc: Blob;

  confirmedDocControl = new FormControl('', Validators.required);
  unconfirmedDocControl = new FormControl('', Validators.required);

  unconfirmedDocList: Doc[] = [];
  confirmedDocList: Doc[] = [];


  public isConfirm:boolean;
  public isCheckDisabled: boolean = true;
  public isPrintDisabled: boolean = true;
  public buttonText:string="ONAYLA";

  constructor(
    public personelService: PersonelService,
    public dialog:MatDialog,
    public spinner:NgxSpinnerService,
    public printService: NgxExtendedPdfViewerService,
  ) {

    // 2 puantaj için
    personelService.getDocumentList("2").subscribe(res => {
      //console.log(res);
      res.forEach(elm => {

        if(elm.IsRead){
          this.confirmedDocList.push({
            DocumentName: elm.DocumentName,
            Id: elm.Id,
            Month: elm.Month,
            Year: elm.Year,
            IsRead: elm.IsRead,
          });
        }else{
          this.unconfirmedDocList.push({
            DocumentName: elm.DocumentName,
            Id: elm.Id,
            Month: elm.Month,
            Year: elm.Year,
            IsRead: elm.IsRead,
          });
        }


       
      });
    });


    //dökuman objesi .property şeklinde devam et 
    //console.log(this.docControl.value);
  }


  showPdf() {
    this.buttonText ="ONAYLA";
    let canRead = true;
    this.isConfirm = false;

    this.unconfirmedDocList.forEach(data => {
      if (data.Id !== this.unconfirmedDocControl.value.Id) {
      /*  if (this.docControl.value.isRead) {
          canRead = false;
        }*/
        if (parseInt(data.Year) < parseInt(this.unconfirmedDocControl.value.Year)) {
          canRead = false;
        }
        if (((parseInt(data.Month) < parseInt(this.unconfirmedDocControl.value.Month)) && parseInt(data.Year) == parseInt(this.unconfirmedDocControl.value.Year))) {
          canRead = false;
        }
      }
    });

    this.spinner.show();
    if (canRead) {
      //console.log("indircem!");
      this.personelService.getDocument(this.unconfirmedDocControl.value.Id).subscribe(res => {

        this.pdfSrc = res;
        this.isCheckDisabled = false;
        this.isPrintDisabled = false;


        this.spinner.hide();



      });
    }else {
      this.spinner.hide();
      //console.log("Daha önceden onaylanmamış puantaj var  ALOOO !!");
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: false,
            text: "Daha önceki dönemden onaylanmamış puantaj var !",
            subject: "Hatalı Puantaj"
          }
        }).afterClosed().subscribe(() => {
          this.unconfirmedDocControl.setValue(null);
          this.isCheckDisabled = true;
          this.isPrintDisabled = true;
          this.isConfirm = false;
          this.pdfSrc = null;
        });
      }
    }

    downloadPdf(){
      //you can enter your own file name and extension
      this.printService.getCurrentDocumentAsBlob().then(blob =>{
        var a = document.createElement('a');
        var file = new Blob([blob], {type: 'application/pdf'});
        a.href = URL.createObjectURL(file);
        a.download = 'puantaj.pdf';
        a.click();
      });
    }
  

    showConfirmedPdf(){

      this.spinner.show();
  
      this.isConfirm = true;
      this.isCheckDisabled = true;
      this.isPrintDisabled = false;
      
  
        //console.log("indircem!");
        this.personelService.getDocument(this.confirmedDocControl.value.Id).subscribe(res => {
  
          this.pdfSrc = res;
  
          this.buttonText ="ONAYLANDI";
   
           this.spinner.hide();
  
        });
    }

  
    printPdf(){
      this.printService.print();
    }


  
    confirmPdf() {
      if (this.isConfirm) {
       /* this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: true,
            text: "GÖNDER CANIM!",
            subject: "Onaylanmamış Bordro"
          }
        });*/
        this.spinner.show();
        this.personelService.checkDocument(this.unconfirmedDocControl.value.Id).subscribe(res=>{
          this.spinner.hide();
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess: true,
              text: "Puantajı Onayladınız.",
              subject: "Puantaj Onaylama"
            }
          }).afterClosed().subscribe(()=>{
            this.confirmedDocList.push(this.unconfirmedDocList.splice(0, 1)[0]);
            this.isCheckDisabled = true;
            this.isPrintDisabled = true;
            this.isConfirm = false;
            this.pdfSrc = null;
          });
        },
        error => {
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess: false,
              text: error.error.error,
              subject: "Puantaj Onaylama"
            }
          });
        });
  
      } else {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: false,
            text: "Lütfen Puantajı  onaylayın !",
            subject: "Onaylanmamış Puantaj"
          }
        });
      }
  
    }


  ngOnInit(): void {
  }

}
